/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import { useAccountResourceService } from 'domain/shared/account';

const ACCOUNT_CONTEXT = 'Account';

const AccountContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissions } = useAccountResourceService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={ACCOUNT_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default AccountContext;
